var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagesEs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.625,
    height: 160.847,
    viewBox: "0 0 126.625 160.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .mes1{fill:#f0f8ed;stroke:#c1e3b5;stroke-miterlimit:10}.mes2{fill:#e0f1da}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    transform: "translate(-66.756 -71.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    transform: "translate(67.256 72.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    transform: "translate(27.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_51",
    d: "M0 0H3.673V0.622H0z",
    className: "mes1",
    transform: "rotate(-86.302 67.324 -33.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_52",
    d: "M0 0H12.067V0.622H0z",
    className: "mes1",
    transform: "rotate(-86.308 64.07 -36.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    d: "M210.164 72.382h-73.148a7.563 7.563 0 0 0-7.418 6.966l-9.447 145.915a6.468 6.468 0 0 0 6.516 6.966h73.147a7.563 7.563 0 0 0 7.418-6.966l9.447-145.915a6.468 6.468 0 0 0-6.515-6.966z",
    className: "mes1",
    transform: "translate(-120.137 -72.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    fill: "#f0f8ed",
    stroke: "#c1e3b5",
    strokeMiterlimit: 10,
    d: "M207.841 72.382h-70.825a7.563 7.563 0 0 0-7.418 6.966l-9.447 145.915a6.468 6.468 0 0 0 6.516 6.966h70.825a7.563 7.563 0 0 0 7.417-6.966l9.447-145.915a6.468 6.468 0 0 0-6.515-6.966z",
    opacity: 0.7,
    transform: "translate(-120.137 -72.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    d: "M203.427 233.187h-77.909a2.13 2.13 0 0 1-2.125-2.268l8.548-132.035a2.13 2.13 0 0 1 2.125-1.992h77.909a2.13 2.13 0 0 1 2.125 2.268l-8.548 132.034a2.13 2.13 0 0 1-2.125 1.993z",
    className: "mes1",
    transform: "translate(-121.694 -84.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    d: "M216.766 86.523h-28.317a1.045 1.045 0 0 1-1.056-1.129 1.222 1.222 0 0 1 1.2-1.129h28.317a1.045 1.045 0 0 1 1.056 1.129 1.221 1.221 0 0 1-1.2 1.129z",
    className: "mes1",
    transform: "translate(-152.346 -78.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    d: "M196.247 366.552a2.954 2.954 0 0 1-2.917 2.774 2.608 2.608 0 0 1-2.63-2.774 2.954 2.954 0 0 1 2.917-2.774 2.608 2.608 0 0 1 2.63 2.774z",
    className: "mes1",
    transform: "translate(-153.929 -211.938)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    d: "M195.672 167.077h-66.527l-4.226 65.278h70.753a6.987 6.987 0 0 0 6.967-6.967v-51.345a6.987 6.987 0 0 0-6.967-6.966z",
    className: "mes2",
    transform: "translate(-94.872 -117.734)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    transform: "translate(0 38.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    d: "M73.107 152.331a.62.62 0 0 1-.44-.182l-1.116-1.116a.622.622 0 0 1 .88-.88l1.116 1.116a.622.622 0 0 1-.44 1.062z",
    className: "mes1",
    transform: "translate(-69.226 -147.829)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    d: "M69.455 160.848h-1.577a.622.622 0 0 1 0-1.244h1.577a.622.622 0 0 1 0 1.244z",
    className: "mes1",
    transform: "translate(-67.256 -152.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    d: "M81.63 148.679a.623.623 0 0 1-.62-.578l-.112-1.574a.622.622 0 1 1 1.241-.089l.113 1.574a.622.622 0 0 1-.576.665z",
    className: "mes1",
    transform: "translate(-73.788 -145.861)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    d: "M169.5 155.936H83.9a4.949 4.949 0 0 0-4.935 4.935v55.408a4.95 4.95 0 0 0 4.935 4.935h56.473l18.327 18.319v-18.319h10.8a4.95 4.95 0 0 0 4.935-4.935v-55.408a4.95 4.95 0 0 0-4.935-4.935z",
    className: "mes1",
    transform: "translate(-72.867 -150.686)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    transform: "translate(17.317 13.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    transform: "translate(14.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    d: "M165.381 211.639l-1.28-5.579a10.068 10.068 0 0 1-.011-4.448l1.781-7.946a15.577 15.577 0 0 0-8.239-17.277 3.649 3.649 0 0 0 .149-.449 3.76 3.76 0 1 0-7.337-1.644 3.7 3.7 0 0 0-.056.469 15.576 15.576 0 0 0-14.823 12.11l-1.781 7.946a10.059 10.059 0 0 1-1.908 4.019l-3.537 4.5a3.318 3.318 0 0 0 1.883 5.288l31.2 6.99a3.318 3.318 0 0 0 3.959-3.979z",
    className: "mes1",
    transform: "translate(-127.627 -171.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    d: "M153.214 251.934a1.477 1.477 0 0 0-1.772 1.7 5.4 5.4 0 0 0 9.745 2.183 1.477 1.477 0 0 0-.878-2.292z",
    className: "mes1",
    transform: "translate(-139.022 -209.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    d: "M162.782 254.865l-.708-.158a1.483 1.483 0 0 1 .163 1.9 5.4 5.4 0 0 1-5.605 2.177l-.048-.013a5.4 5.4 0 0 0 7.076-1.611 1.477 1.477 0 0 0-.878-2.295z",
    className: "mes2",
    transform: "translate(-141.495 -211.276)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    d: "M132.253 204.289l3.538-4.5a10.069 10.069 0 0 0 1.908-4.019l1.78-7.946a15.576 15.576 0 0 1 14.823-12.11 3.544 3.544 0 0 1 2.518-3.2 3.759 3.759 0 0 0-6.375 1.786 3.817 3.817 0 0 0-.056.469 15.576 15.576 0 0 0-14.823 12.11l-1.781 7.946a10.058 10.058 0 0 1-1.908 4.019l-3.537 4.5a3.318 3.318 0 0 0 1.883 5.288l3.259.731a3.32 3.32 0 0 1-1.229-5.074z",
    className: "mes2",
    transform: "translate(-113.486 -171.358)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    transform: "translate(0 1.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    d: "M104.862 203.313a.984.984 0 0 1-.82-.438 21.069 21.069 0 0 1 5.824-29.223.985.985 0 0 1 1.094 1.639 19.1 19.1 0 0 0-5.28 26.49.985.985 0 0 1-.819 1.532z",
    className: "mes1",
    transform: "translate(-100.489 -173.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    d: "M113.655 204.363a.982.982 0 0 1-.82-.438 16.048 16.048 0 0 1 4.436-22.258.985.985 0 0 1 1.094 1.639 14.077 14.077 0 0 0-3.892 19.525.985.985 0 0 1-.819 1.532z",
    className: "mes1",
    transform: "translate(-105.105 -177.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    d: "M122.448 205.413a.985.985 0 0 1-.82-.438 11.028 11.028 0 0 1 3.048-15.3.985.985 0 0 1 1.094 1.639 9.057 9.057 0 0 0-2.5 12.562.985.985 0 0 1-.818 1.532z",
    className: "mes1",
    transform: "translate(-109.722 -181.162)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    transform: "translate(55.583 15.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    d: "M216.985 230.656a.985.985 0 0 1-.453-1.861 19.1 19.1 0 0 0 8.209-25.733.985.985 0 0 1 1.751-.9 21.071 21.071 0 0 1-9.056 28.388.992.992 0 0 1-.451.106z",
    className: "mes1",
    transform: "translate(-211.392 -201.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    d: "M212.565 228.312a.985.985 0 0 1-.453-1.861 14.077 14.077 0 0 0 6.051-18.968.985.985 0 1 1 1.751-.9 16.049 16.049 0 0 1-6.9 21.623.982.982 0 0 1-.449.106z",
    className: "mes1",
    transform: "translate(-209.275 -203.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    d: "M208.144 225.968a.985.985 0 0 1-.453-1.861 9.056 9.056 0 0 0 3.893-12.2.985.985 0 1 1 1.751-.9 11.041 11.041 0 0 1-4.74 14.858.983.983 0 0 1-.451.103z",
    className: "mes1",
    transform: "translate(-207.158 -205.86)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesEs);
export default __webpack_public_path__ + "static/media/messages-es.df01991b65ce80ceb65f62bbe8bc077b.svg";
export { ForwardRef as ReactComponent };